<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation`">创新创业</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation/roadshow-list`">路演大厅</el-breadcrumb-item>
        <el-breadcrumb-item>{{ model.Headline }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="detail-content">
        <div class="left">
          <div class="video" :style="
              'background:url(' +
                model.Picture +
                ') no-repeat;background-position: center;'
            ">
            <div v-if="model.TypeId == 1||model.TypeId ==2" class="play">
              <a :href="model.LiveUrl" target="_blank">
                <i class="el-icon-video-play icon"></i>
              </a>
            </div>
          </div>
          <div class="name">{{ model.Headline }}</div>
          <div class="attrs">
            <span>{{ formartDate(model.StartTime, "minutes") }}播放</span>
            <span>结束时间：{{ formartDate(model.EndTime, "minutes") }}</span>
          </div>
          <column-header2 :data="{ name: '路演详情' }"></column-header2>
          <div class="content" v-html="model.Contents"></div>
        </div>
        <div class="right">
          <column-header2 :data="{ name: '路演推荐' }"></column-header2>
          <div v-if="preachList.length ">
            <preach-card v-for="item in preachList" :data="item" :key="item.id"></preach-card>
          </div>
          <div v-else class="attrs">
            <span>暂无推荐</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail, getData } from "api/app";
import { updateEntity } from "api/content-data";
import PreachCard from "./components/PreachCard";
import ColumnHeader from "_c/ColumnHeader2";
import toolMixin from "@/mixins/content-tools.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      model: {
        title: "",
        time: "",
        source: "",
        content: "",
        id: "1",
        prev: null,
        next: null
      },

      id: null,
      preachList: []
    };
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  mixins: [toolMixin],
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    [PreachCard.name]: PreachCard
  },
  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    loadData() {
      getDetail({ name: this.$route.params.name, id: this.id }).then(res => {
        this.model = res || {};
      });
      const params = [
        { Key: "College", Value: this.collegeData.cid, CompareType: "EqualTo" },
        { Key: "WorkFlowState", Value: 2, CompareType: "GreaterThan" }
      ];
      getData({ name: this.$route.params.name, top: 3, params: params }).then(
        res => {
          const arr = [];
          res.forEach(item => {
            if (item.Id != this.id) {
              arr.push({
                id: item.Id,
                pic: item.Picture,
                name: item.Headline,
                view: item.ViewCount,
                time: item.StartTime,
                link: item.LiveUrl
              });
            }
          });
          this.preachList = arr || [];
        }
      );
    },
    updateViewCount() {
      var dic = {};
      dic.TableId = this.$route.params.name;
      dic.Id = this.$route.query.id;
      dic.ViewCount = (this.model.view ?? 0) + 1;
      updateEntity(dic)
        .then(res => {
          if (res.IsSuccess) {
            console.log("更新浏览量成功");
          }
        })
        .catch(err => {
          console.log("更新浏览量异常" + err);
        });
    },
    init() {
      this.id = this.$route.query.id;
      this.loadData();
      // this.updateViewCount();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-detail {
  .detail-content {
    display: flex;
    justify-content: space-between;
    .left {
      width: 776px;
      .video {
        // background-color: rgba($color: #000000, $alpha: 0.5);
        width: 776px;
        height: 436px;
        overflow: hidden;
        background-size: cover !important;
        position: relative;
        .play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          .icon {
            font-size: 80px;
            background-color: rgba(0, 0, 0, 1);
            border-radius: 50%;
          }
        }
      }
      .name {
        font-size: 26px;
        line-height: 40px;
        padding: 24px 0 16px 0;
      }
      .attrs {
        font-size: 15px;
        color: rgba(102, 102, 102, 1);
        line-height: 22px;
        border-bottom: 1px solid #eee;
        padding-bottom: 24px;
        vertical-align: middle;
        span {
          position: relative;
          padding-left: 10px;
          margin-left: 10px;
          &::before {
            width: 1px;
            height: 12px;
            background-color: #ccc;
            position: absolute;
            left: 0;
            top: 2px;
            content: ' ';
          }
        }
        span:first-child {
          padding-left: 0;
          margin-left: 0;
          &::before {
            display: none;
          }
        }
      }
      .content {
        line-height: 32px;
        color: #666;
        font-size: 15px;
      }
      ::v-deep .comp-column-header {
        padding-top: 24px;
      }
    }
    .right {
      width: 376px;
      ::v-deep .comp-preach {
        margin-left: 0 !important;
      }
      ::v-deep .comp-column-header:first-child {
        padding-top: 0;
      }
    }
  }
}
</style>
